import React, { useState } from "react";
import {
  Menu as MenuIcon
} from "@mui/icons-material";
import FlexBetween from "components/FlexBetween";
import {
  AppBar,
  Typography,
  IconButton,
  Box,
  Toolbar,
} from "@mui/material";

const Navbar = ({ user, isSidebarOpen, setIsSidebarOpen }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <AppBar
      sx={{
        position: "static",
        background: "none",
        boxShadow: "none",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* LEFT SIDE */}
        <FlexBetween>
          <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <MenuIcon />
          </IconButton>
        </FlexBetween>
{/* CENTERED TEXT */}
<Box
          display="flex"
          alignItems="start"
          justifyContent="start"
          flex="1"
          sx={{ marginLeft: "2rem" }}
        >
          <Typography
            variant="h3"
            fontWeight="normal"
            sx={{ color: "inherit"}}
          >
            STATE - NOC
          </Typography>
        </Box>
        {/* RIGHT SIDE */}
        <FlexBetween gap="1.5rem">
        </FlexBetween>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
